import React from "react"
import { Modal } from "react-bootstrap"
import "./ConfirmModal.scss"

export function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  isConfirmLoading = false,
  isConfirmDisabled = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      show={isOpen}
      onHide={onCancel}
      centered
      backdrop="static"
      className="admin-confirm-modal"
      aria-labelledby="adminConfirmModalLabel"
    >
      <Modal.Header>
        <Modal.Title id="adminConfirmModalLabel">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="admin-confirm-message">{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="close-btn"
          onClick={onCancel}
          disabled={isConfirmLoading}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className="red-btn"
          onClick={onConfirm}
          disabled={isConfirmLoading || isConfirmDisabled}
        >
          {isConfirmLoading ? "Processing..." : confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

